<template>
  
  <div class="ui grid animated fadeIn">
    <div class="ui sixteen wide column">
      <file-upload
        ref="fileUpload"
        :uploadPath="`/animal-registrations/${this.registration.id}/attachments?private=true`"
        :loader="loadFiles"        
        @onRemove="onRemoveFile"
      /> 
    </div>
  </div>    

</template>

<script>

  import AnimalRegistrationService from "@/services/animal-registration-service"
  import FileUpload from "@/components/file-upload"

  export default {
    
    name: "AnimalRegistrationPrivateAttachments",

    data() {
      return {
        service: new AnimalRegistrationService(),
      }
    },

    props: ["registration"],

    components: {
      FileUpload,
    },

    mounted() {
      this.$refs.fileUpload.loadFiles()
    },

    methods: {

      async loadFiles() {
        return this.service.getPrivateAttachments(this.registration.id)        
      }, 

      async onRemoveFile(file) {

        try {

          await this.service.removePrivateAttachment(this.registration.id, file)           
          
        } catch (error) {
          
          this.$errorHandler(error)
        }
      },
    },
  }

</script>